import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Server, Wind, Square, Zap, Briefcase, CheckCircle } from 'lucide-react';
import PageHeader from './PageHeader';
import SpotlightCard from './SpotlightCard';
import './Multiservicos.css';

const Multiservicos = () => {
  const services = [
    {
      title: 'Telecomunicações',
      description: 'Serviços completos de telefonia, PABX, ramais e infraestrutura de telecomunicações.',
      icon: Phone
    },
    {
      title: 'Tecnologia',
      description: 'Soluções em TI, redes, servidores, cloud computing e infraestrutura tecnológica.',
      icon: Server
    },
    {
      title: 'Ar-Condicionado',
      description: 'Instalação, manutenção e suporte de sistemas de climatização.',
      icon: Wind
    },
    {
      title: 'Divisórias',
      description: 'Projeto, instalação e reforma de divisórias e estruturas modulares.',
      icon: Square
    },
    {
      title: 'Elétrica',
      description: 'Instalações elétricas, cabeamento estruturado e infraestrutura elétrica completa.',
      icon: Zap
    },
    {
      title: 'Infraestrutura Completa',
      description: 'Todos os itens necessários para o pleno funcionamento do ambiente empresarial.',
      icon: Briefcase
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <>
      <PageHeader
        title="Fornecedor Único"
        subtitle="Metodologia integrada para atender todas as necessidades da sua empresa."
        breadcrumb="Multisserviços"
      />

      <section className="multiservicos section">
        <div className="container">
          <motion.div
            className="multiservicos-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="intro-text">
              Em 2026 completamos <strong>25 anos de atuação</strong> e adotamos uma metodologia de multisserviços
              atendendo os clientes em praticamente toda sua necessidade, da implantação a manutenção.
            </p>
            <p className="intro-text mt-4">
              Com o conceito de <strong>fornecedor único</strong>, acompanhamos nossos clientes desde a proposta, não só
              nos serviços de telecom e tecnologia, como também toda a infra necessária de ar-condicionado,
              divisórias, elétrica, e todos os itens necessários para o pleno funcionamento do ambiente.
            </p>
          </motion.div>

          <div className="multiservicos-benefits">
            <h3 className="section-title-sm">Nossos Serviços Integrados</h3>
            <motion.div
              className="services-grid"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
            >
              {services.map((service, index) => (
                <motion.div key={index} variants={itemVariants}>
                  <SpotlightCard className="h-full" spotlightColor="rgba(0, 0, 0, 0.04)">
                    <div className="service-card-inner">
                      <div className="service-icon-box">
                        <service.icon size={28} />
                      </div>
                      <h4 className="service-card-title">{service.title}</h4>
                      <p className="service-card-description">{service.description}</p>
                    </div>
                  </SpotlightCard>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <motion.div
            className="multiservicos-advantage"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <SpotlightCard className="advantage-card" spotlightColor="rgba(220, 38, 38, 0.05)">
              <div className="advantage-content">
                <div className="advantage-header">
                  <h3 className="advantage-title">Vantagens do Fornecedor Único</h3>
                  <p className="advantage-subtitle">Por que centralizar é a melhor estratégia?</p>
                </div>
                <div className="advantage-list-container">
                  <ul className="advantage-list">
                    {[
                      "Atendimento integrado desde a proposta até a manutenção",
                      "Redução de custos operacionais e administrativos",
                      "Coordenação única de todos os serviços",
                      "Maior agilidade na execução dos projetos",
                      "Responsabilidade única por toda a infraestrutura",
                      "Suporte técnico unificado e especializado"
                    ].map((item, i) => (
                      <li key={i}>
                        <CheckCircle size={20} className="check-icon" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </SpotlightCard>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Multiservicos;


